module.exports = __webpack_public_path__ + "static/img/hdb.0c3be24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/hdb.jpg
// module id = FwIa
// module chunks = 0